<template>
  <div class="modal">
    <button class="modal__close" @click="close">
      <font-awesome-icon :icon="['far', 'times']" />
    </button>
    <header class="modal__header" v-if="title || $slots['header']">
      <slot name="header">
        <h1 class="modal__title">{{ title }}</h1>
      </slot>
    </header>
    <div class="modal__body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'BaseModal',

  components: {
    FontAwesomeIcon,
  },

  props: {
    title: {
      default: '',
      type: String,
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/variables';

.modal {
  &__close {
    font-size: 18px;
    font-weight: 300;
    position: absolute;
    top: 24px;
    right: 28px;
    color: white;
    cursor: pointer;
  }

  &__header {
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(white, 0.2);
  }

  &__title {
    font-size: 14px;
    font-weight: 400;
    margin: 0;
    text-transform: uppercase;
  }
}
</style>
